import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { RELEASE_URL } from '../../config/env';
import { MENU_ROUTES } from '../../constants';
import { Button, IconArrowRight as ArrowRight } from '../../core';
import { ReactComponent as Logo } from '../../images/dhcs.svg';
import HeaderNavigationStyled from '../HeaderNavigation';

interface Props {
  className?: string;
}

const Header = ({ className = '' }: Props) => (
  <div className={className}>
    <Link to={MENU_ROUTES.overview.path}>
      <Logo />
    </Link>

    <HeaderNavigationStyled />

    <Button
      onClick={() => (window.location.href = RELEASE_URL)}
      variant="primary"
      size="M"
      iconAfter={<ArrowRight />}
    >
      Open Builder
    </Button>
  </div>
);

const HeaderStyled = styled(Header)`
  display: flex;
  position: relative;
  z-index: 20;
  background-color: ${({ theme }) => theme.neutralBackgroundMedium};
  padding: 0 1.25rem;
  height: 4rem;
  grid-area: header;
  align-items: center;
  justify-content: space-between;
`;

export default HeaderStyled;
